// extracted by mini-css-extract-plugin
export var googlemap = "embedmap-module--googlemap--211aa";
export var mapwrapper = "embedmap-module--mapwrapper--e145c";